export default "images/overlook-logo.jpg";